import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip } from '@mui/material';
import { Edit, Delete, Send } from '@mui/icons-material';
import BaseModal from '../../../utils/BaseModal';
import api from '../../../../api/axios';
import { toast } from 'react-toastify';

type Props = {
  open: boolean;
  onClose: () => void;
  onSelectForCampaign: (template: any) => void;
  onEdit: (template: any) => void;
};

const ShowTemplatesModal: React.FC<Props> = ({ open, onClose, onSelectForCampaign, onEdit }) => {
  const [templates, setTemplates] = useState<any[]>([]);

  const fetchTemplates = async () => {
    try {
      const res = await api.get('/system/newsletter/templates');
      setTemplates(res.data);
    } catch (e) {
      console.error("Failed to fetch templates");
    }
  };

  useEffect(() => {
    if (open) fetchTemplates();
  }, [open]);

  const handleDelete = async (id: number) => {
    if (!window.confirm("Delete this template?")) return;
    try {
      await api.delete(`/system/newsletter/templates/${id}`);
      toast.success("Template deleted");
      fetchTemplates();
    } catch (e) {
      toast.error("Error deleting template");
    }
  };

  return (
      <BaseModal open={open} title="Newsletter Templates" onAbort={onClose} maxWidth="md">
        <TableContainer component={Paper} className="bg-transparent shadow-none">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className="text-neutral-400 uppercase text-[10px] font-black">Name</TableCell>
                <TableCell className="text-neutral-400 uppercase text-[10px] font-black">Created</TableCell>
                <TableCell align="right" className="text-neutral-400 uppercase text-[10px] font-black">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {templates.map((t) => (
                  <TableRow key={t.id} className="hover:bg-white/5 transition-colors">
                    <TableCell className="text-white font-medium border-white/5">{t.name}</TableCell>
                    <TableCell className="text-neutral-500 border-white/5 text-xs">
                      {new Date(t.createdAt).toLocaleDateString('de-DE')}
                    </TableCell>
                    <TableCell align="right" className="border-white/5">
                      <div className="flex justify-end gap-1">
                        <Tooltip title="Use for Campaign">
                          <IconButton size="small" onClick={() => onSelectForCampaign(t)} className="text-emerald-500">
                            <Send sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                        <IconButton size="small" onClick={() => onEdit(t)} className="text-blue-400">
                          <Edit sx={{ fontSize: 18 }} />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete(t.id)} className="text-red-500">
                          <Delete sx={{ fontSize: 18 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </BaseModal>
  );
};

export default ShowTemplatesModal;